module.exports = __webpack_public_path__ + "static/media/logo.f6603ff0.png";


//////////////////
// WEBPACK FOOTER
// ./src/logo.png
// module id = 78
// module chunks = 0